/**
 * DataLayer utilities for GTM integration.
 * Pushes GA4-standard ecommerce events to window.dataLayer.
 */
function getDataLayer() {
    if (typeof window === 'undefined')
        return null;
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
}
/**
 * Push a GA4-standard ecommerce event to the dataLayer.
 * Always clears ecommerce first per GA4 best practice.
 */
function pushEcommerceEvent(event) {
    const dl = getDataLayer();
    if (!dl)
        return;
    // Clear previous ecommerce data
    dl.push({ ecommerce: null });
    dl.push({
        event: event.event,
        event_id: event.event_id,
        ecommerce: event.ecommerce,
        ekho: event.ekho,
        ...(event.user_data && { user_data: event.user_data }),
    });
}
/**
 * Push a simple (non-ecommerce) event to the dataLayer.
 * When eventId is provided, it's included as `event_id` for server-side GTM dedup.
 */
function pushDataLayerEvent(eventName, properties = {}, eventId) {
    const dl = getDataLayer();
    if (!dl)
        return;
    dl.push({ event: eventName, ...(eventId && { event_id: eventId }), ...properties });
}

export { pushDataLayerEvent, pushEcommerceEvent };
//# sourceMappingURL=data-layer.js.map
